"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _createSources["default"];
  }
});
var _createSources = _interopRequireDefault(require("./createSources"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }